import type { Ref } from "vue";
import { useIncomingCall } from "./useIncomingCall";

export function useLiveCaption(_options: {
  callSid: Ref<string | null | undefined>;
  isActive: Ref<boolean>;
  enabled: Ref<boolean>;
}) {
  const { transcriptionMessages } = useIncomingCall();
  return { messages: transcriptionMessages };
}
